import {Component} from '@angular/core';

@Component({
  selector: 'app-notification-snack-bar',
  templateUrl: './notification-snack-bar.component.html',
})
export class NotificationSnackBarComponent {

}
